<template>
  <modal-wrap
    ref="downloadModal"
    :name="modalName"
    :header-class="'service-level-header'"
    :body-class="'service-level-modal'"
    :hide-footer="false"
    size="lg"
  >
    <template #modal-title> Download Shipping Labels</template>
    <template #default>
      <div class="d-flex align-items-center">
        <h2 class="modal-sub-title mr-2">Labels preferences</h2>
        <span v-b-tooltip="{ title: preferenceTooltip, placement: 'bottom', class: 'download-tooltip-info' }">
          <img src="@/assets/img/ant-design_question-circle-outlined.svg" alt="" />
        </span>
      </div>
      <b-form-group>
        <div class="d-flex mt-2">
          <div class="mr-3 custom-control custom-radio">
            <input
              id="consolidated_value"
              v-model="labelsType"
              type="radio"
              name="consolidated"
              class="custom-control-input"
              value="consolidated"
            />
            <label class="custom-control-label" for="consolidated_value"> Combine in 1 file </label>
          </div>
          <div class="custom-control custom-radio">
            <input
              id="separate_value"
              v-model="labelsType"
              type="radio"
              name="consolidated"
              class="custom-control-input"
              value="separate"
            />
            <label class="custom-control-label" for="separate_value"> Separately </label>
          </div>
        </div>
      </b-form-group>
      <div class="row row-flex mt-4">
        <div class="col-12 mb-2">
          <div class="download-labels-group">
            <div class="download-labels-group__title">
              <mdicon name="printer" size="25" />
              Standard printers (A4 format)
            </div>
            <div class="download-labels-group__types">
              <div
                class="download-labels-group-type download-labels-group-type_landscape"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('a4_landscape', 'pairs'),
                }"
                @click="setSubTypeAndPosition('a4_landscape', 'pairs')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_landscape">
                  <div class="download-labels-group-type-visual__body d-flex justify-content-between">
                    <div class="download-labels-group-type-visual__rectangle" />
                    <div class="download-labels-group-type-visual__rectangle" />
                  </div>
                </div>
                <div class="download-labels-group-type__title">A4 Landscape 2 x 2</div>
              </div>
              <div
                class="download-labels-group-type download-labels-group-type_landscape"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('a4_landscape', 'single'),
                }"
                @click="setSubTypeAndPosition('a4_landscape')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_landscape">
                  <div class="download-labels-group-type-visual__body d-flex justify-content-between">
                    <div class="download-labels-group-type-visual__rectangle" />
                    <div class="download-labels-group-type-visual__rectangle bg-grey" />
                  </div>
                </div>
                <div class="download-labels-group-type__title">A4 Landscape 1 x 2</div>
              </div>
              <div
                class="download-labels-group-type download-labels-group-type_landscape"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('a4_landscape', 'triplets'),
                }"
                @click="setSubTypeAndPosition('a4_landscape', 'triplets')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_landscape">
                  <div class="download-labels-group-type-visual__body d-flex justify-content-between">
                    <div class="download-labels-group-type-visual__rectangle mr-1 rectangle-small">
                      <span class="landscape" />
                    </div>
                    <div class="download-labels-group-type-visual__rectangle rectangle-small">
                      <span class="landscape" />
                    </div>
                    <div class="download-labels-group-type-visual__rectangle ml-1 rectangle-small">
                      <span class="landscape" />
                    </div>
                  </div>
                </div>
                <div class="download-labels-group-type__title">A4 Landscape 3 x 3</div>
              </div>
              <div
                class="download-labels-group-type download-labels-group-type_portrait"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('a4_portrait'),
                }"
                @click="setSubTypeAndPosition('a4_portrait')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_portrait">
                  <div class="download-labels-group-type-visual__body">
                    <div class="download-labels-group-type-visual__rectangle" />
                  </div>
                </div>
                <div class="download-labels-group-type__title">A4 Portrait 1 x 1</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="download-labels-group">
            <div class="download-labels-group__title">
              <mdicon name="printerPos" size="25" />
              Recommended for Zebra 420d
            </div>
            <div class="download-labels-group__types">
              <div
                class="download-labels-group-type download-labels-group-type_zebra-big"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('zebra_big'),
                }"
                @click="setSubTypeAndPosition('zebra_big')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_zebra-big">
                  <div class="download-labels-group-type-visual__body">
                    <div class="download-labels-group-type-visual__rectangle" />
                  </div>
                </div>
                <div class="download-labels-group-type__title">105 x 190 mm</div>
              </div>
              <div
                class="download-labels-group-type download-labels-group-type_zebra-small"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('zebra_small'),
                }"
                @click="setSubTypeAndPosition('zebra_small')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_zebra-small">
                  <div class="download-labels-group-type-visual__body">
                    <div class="download-labels-group-type-visual__rectangle" />
                  </div>
                </div>
                <div class="download-labels-group-type__title">105 x 72 mm</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showLetterWindow" class="col-6">
          <div class="download-labels-group">
            <div class="download-labels-group__title">
              <mdicon name="emailOutline" size="25" />
              C5 letter window
            </div>
            <div class="download-labels-group__types">
              <div
                class="download-labels-group-type download-labels-group-type_letter-window"
                :class="{
                  'download-labels-group-type_active': isSubTypeAndPosition('letter_window'),
                }"
                @click="setSubTypeAndPosition('letter_window')"
              >
                <div class="download-labels-group-type-visual download-labels-group-type-visual_letter-window">
                  <div class="download-labels-group-type-visual__body">
                    <div class="download-labels-group-type-visual__rectangle" />
                  </div>
                </div>
                <div class="download-labels-group-type__title">
                  A4 – recipient window
                  <small class="d-block">82.5 × 18 mm safe area - one page per recipient</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <b-button size="md" class="btn-grey mr-3" @click="closeModal"> Cancel</b-button>
      <b-button variant="success" size="md" class="btn-green" @click="downloadLabels"> Download labels</b-button>
    </template>
  </modal-wrap>
</template>

<script lang="ts">
import type { DownloadLabelsModalData } from '@/types/Models/Labels'
import { notify } from '@kyvg/vue3-notification'
import { BButton, BFormGroup } from 'bootstrap-vue-next'
import { ref, computed, defineComponent, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { LETTER } from '@/const/DistributionChannels'
import { LABELS_DOWNLOAD_LOADER } from '@/const/LoadersNames'
import { DOWNLOAD_LABELS } from '@/const/ModalTypes'
import { useUiStore } from '@/store/ui'
import { useVueNextModalStore } from '@/store/vueNextModal'
import { STAFF_ASSIGNMENTS_LIST } from '@/types/router'
import ModalWrap from '@/views/Modals/ModalWrap.vue'
import AssignmentProxy from '@/proxies/AssignmentProxy'

export default defineComponent({
  name: 'DownloadLabelsModal',
  components: { BFormGroup, BButton, ModalWrap },
  setup() {
    const modalStore = useVueNextModalStore()
    const router = useRouter()
    const route = useRoute()
    const uiStore = useUiStore()

    const labelsType = ref('consolidated')
    const format = ref('a4_landscape')
    const positioning = ref('pairs')
    const modalName = DOWNLOAD_LABELS

    const preferenceTooltip =
      'Choose how you would like your labels delivered:\n' +
      'Combined in 1 file - all labels will be placed inside one multi-page PDF.\n' +
      'Separately - each label will be saved as a separate PDF file and placed inside one ZIP archive.\n'

    const modalData = computed<DownloadLabelsModalData | undefined>(() => modalStore.modalPropsByName(modalName))
    const assignmentsIds = computed(() => modalStore.modalPropsByName(modalName)?.ids || [])
    const showLetterWindow = computed(
      () =>
        !!modalData.value?.assignments?.length &&
        modalData.value.assignments.every((assignment) => assignment.distributionChannel === LETTER),
    )

    const setSubTypeAndPosition = (subType: string, pos: string = 'single') => {
      format.value = subType
      positioning.value = pos
      if (subType === 'letter_window') {
        labelsType.value = 'consolidated'
      }
    }

    const isSubTypeAndPosition = (subType: string, pos: string = 'single') => {
      return format.value === subType && positioning.value === pos
    }

    const closeModal = () => {
      modalStore.closeModal(modalName)
    }

    const downloadLabels = () => {
      const payload: any = {
        mode: labelsType.value,
        layout: format.value,
        positioning: positioning.value,
        assignments: toRaw(assignmentsIds.value),
      }

      if (route.params.id) {
        payload.id = route.params.id
      } else if (modalData.value?.id) {
        payload.id = modalData.value.id
      }

      new AssignmentProxy()
        .getLabelsMultiple(payload)
        .then(() => {
          uiStore.loaderShow({
            name: LABELS_DOWNLOAD_LOADER,
            data: {
              progress: 0,
              labelsType: labelsType.value,
              callback: () => {
                router.push({ name: STAFF_ASSIGNMENTS_LIST })
              },
            },
          })
          closeModal()
        })
        .catch((e: any) => {
          uiStore.loaderHide({ name: LABELS_DOWNLOAD_LOADER })
          modalStore.closeModal(modalName)
          notify({ group: 'error', text: `Download Error: ${e.message}` })
        })
    }

    return {
      labelsType,
      format,
      positioning,
      modalName,
      modalData,
      assignmentsIds,
      showLetterWindow,
      preferenceTooltip,
      setSubTypeAndPosition,
      isSubTypeAndPosition,
      downloadLabels,
      closeModal,
    }
  },
})
</script>

<style lang="scss" scoped>
@use '@/assets/scss/parts/download_labels_form.scss';
</style>
